import IteachMenu from './menu/index.vue';
import IteachMenuTab from './menuTab/index.vue';

export {
  IteachMenu,
  IteachMenuTab
};

